import React, { PropsWithChildren } from 'react'

import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { ConditionalTrackedRoute } from '@components/UI/TrackedRoute'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectMediaObjectType } from '@store/mediaObjects'

interface IProps {
  eventName: EventTrackingNames
  mediaObjectId?: number
  source?: string
  hasTracking?: boolean
  additionalProperties?: object
}

const ShareableContentLibraryTrackedRoute: React.FC<PropsWithChildren<IProps>> = ({
  eventName,
  mediaObjectId,
  source,
  children,
  additionalProperties,
  hasTracking = true,
}) => {
  const params = useParams<{ token?: string }>()
  const libraryOwner = params.token
  const contentType = useSelector((state: IApplicationState) =>
    selectMediaObjectType(state, mediaObjectId as number),
  )

  return (
    <ConditionalTrackedRoute
      hasTracking={hasTracking}
      eventName={eventName}
      properties={{
        library_owner: libraryOwner,
        content_type: contentType,
        media_object_id: mediaObjectId,
        source,
        ...additionalProperties,
      }}
    >
      {children}
    </ConditionalTrackedRoute>
  )
}

export { ShareableContentLibraryTrackedRoute }
export default ShareableContentLibraryTrackedRoute
